import {
    GETPHYSIOTHERAPYOPDOUT,
    CREATEPHYSIOTHERAPYOPDOUT,
    GETPHYSIOTHERAPYOPDOUTBODYCHARTTYPE,
    CREATEPHYSIOTHERAPYOPDOUTBODYCHARTTYPE,
    UPDATEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD,
    DELETEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD,
    UPDATEPHYSIOTHERAPYPAINASSESSMENTOPDOUT,
    DELETEPHYSIOTHERAPYPAINASSESSMENTOPD,
    GETPHYSIOTHERAPYOPDOUTEXAMINATION,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATION,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATION,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATION,
    GETPHYSIOTHERAPYOPDEXAMINATIONCERVICALSPINE,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE,
    ///
    GETPHYSIOTHERAPYOPDEXAMINATIONTEMROMANDIBULARJOINT,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT,
    //////////
    GETPHYSIOTHERAPYOPDEXAMINATIONSHOLDER,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER,
    GETPHYSIOTHERAPYOPDEXAMINATIONELBOW,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW,
    GETPHYSIOTHERAPYOPDEXAMINATIONWRISTANDFINGERS,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS,
    GETPHYSIOTHERAPYOPDEXAMINATIONTHORACICSPINE,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE,
    GETPHYSIOTHERAPYOPDEXAMINATIONHIP,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP,
    GETPHYSIOTHERAPYOPDEXAMINATIONKNEE,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE,
    GETPHYSIOTHERAPYOPDEXAMINATIONLEANDFOOT,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT,
    GETPHYSIOTHERAPYOPDEXAMINATIONDEEPTENDENREFLEXES,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES,
    GETPHYSIOTHERAPYOPDEXAMINATIONSUPERFICIALREFLEXES,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES,
    GETPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE,
    GETPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY,
    GETPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION,
    GETPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE,
    GETPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION,
    GETPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE,
    CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE,
    UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE,
    DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE,
    GETPHYSIOTHERAPYOPDOUTDIAGNOSIS,
    CREATEPHYSIOTHERAPYOPDOUTDIAGNOSIS,
    UPDATEPHYSIOTHERAPYOPDOUTDIAGNOSIS,
    DELETEPHYSIOTHERAPYOPDOUTDIAGNOSIS,
    GETPHYSIOTHERAPYOPDOUTTREATMENT,
    CREATEPHYSIOTHERAPYOPDOUTTREATMENT,
    UPDATEPHYSIOTHERAPYOPDOUTTREATMENT,
    DELETEPHYSIOTHERAPYOPDOUTTREATMENT,
    GETPHYSIOTHERAPYOPDOUTPROGNOSIS,
    CREATEPHYSIOTHERAPYPROGNOSIS,
    UPDATEPHYSIOTHERAPYOPDOUTPROGNOSIS,
    DELETEPHYSIOTHERAPYOPDOUTPROGNOSIS,
    CREATEPHYSIOTHERAPYOPDOUTPROGNOSIS,
} from '../actions/types';

const initialState = {
    physiotherapyOpdOutList: [],
    createphysiotherapyOpdOutTest: null,
    physiotherapyOpdOutExaminationList: [],
    createphysiotherapyOpdOutBodyChart: null,
}

export default function (state = initialState, action) {
    switch (action.type) {

        case GETPHYSIOTHERAPYOPDOUTTREATMENT:
            return {
                ...state,
                physiotherapyopdouttreatmentList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTTREATMENT:
            return {
                ...state,
                physiotherapyopdouttreatmentSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTTREATMENT:
            return {
                ...state,
                physiotherapyopdouttreatmentUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTTREATMENT:
            return {
                ...state,
                physiotherapyopdouttreatmentDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDOUTDIAGNOSIS:
            return {
                ...state,
                physiotherapyopdoutdiagnosisList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTDIAGNOSIS:
            return {
                ...state,
                physiotherapyopdoutdiagnosisSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTDIAGNOSIS:
            return {
                ...state,
                physiotherapyopdoutdiagnosisUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTDIAGNOSIS:
            return {
                ...state,
                physiotherapyopdoutdiagnosisDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDOUTPROGNOSIS:
            return {
                ...state,
                physiotherapyopdoutprognosisList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTPROGNOSIS:
            return {
                ...state,
                physiotherapyopdoutprognosisSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTPROGNOSIS:
            return {
                ...state,
                physiotherapyopdoutprognosisUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTPROGNOSIS:
            return {
                ...state,
                physiotherapyopdoutprognosisDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE:
            return {
                ...state,
                physiotherapyexaminationtestcerviclespineList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE:
            return {
                ...state,
                physiotherapyopdoutexaminationtestcerviclespineSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE:
            return {
                ...state,
                physiotherapyexaminationtestcerviclespineUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE:
            return {
                ...state,
                physiotherapyexaminationtestcerviclespineDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION:
            return {
                ...state,
                physiotherapyexaminationcoordinationList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION:
            return {
                ...state,
                physiotherapyopdoutexaminationcoordinationSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION:
            return {
                ...state,
                physiotherapyexaminationcoordinationUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION:
            return {
                ...state,
                physiotherapyexaminationcoordinationDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE:
            return {
                ...state,
                physiotherapyexaminationcarnialnerveList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE:
            return {
                ...state,
                physiotherapyopdoutexaminationcarnialnerveSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE:
            return {
                ...state,
                physiotherapyexaminationcarnialnerveUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE:
            return {
                ...state,
                physiotherapyexaminationcarnialnerveDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION:
            return {
                ...state,
                physiotherapyexaminationhigherfunctionList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION:
            return {
                ...state,
                physiotherapyopdoutexaminationhigherfunctionSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION:
            return {
                ...state,
                physiotherapyexaminationhigherfunctionUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION:
            return {
                ...state,
                physiotherapyexaminationhigherfunctionDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY:
            return {
                ...state,
                physiotherapyexaminationsensoryList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY:
            return {
                ...state,
                physiotherapyopdoutexaminationsensorySaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY:
            return {
                ...state,
                physiotherapyexaminationsensoryUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY:
            return {
                ...state,
                physiotherapyexaminationsensoryDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE:
            return {
                ...state,
                physiotherapyexaminationlumberspineList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE:
            return {
                ...state,
                physiotherapyopdoutexaminationlumberspineSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE:
            return {
                ...state,
                physiotherapyexaminationlumberspineUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE:
            return {
                ...state,
                physiotherapyexaminationlumberspineDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDEXAMINATIONSUPERFICIALREFLEXES:
            return {
                ...state,
                physiotherapyexaminationsuperficialreflexesList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES:
            return {
                ...state,
                physiotherapyopdoutexaminationsuperficialreflexesSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES:
            return {
                ...state,
                physiotherapyexaminationsuperficialreflexesUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES:
            return {
                ...state,
                physiotherapyexaminationsuperficialreflexesDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDEXAMINATIONDEEPTENDENREFLEXES:
            return {
                ...state,
                physiotherapyexaminationdeeptendenreflexesList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES:
            return {
                ...state,
                physiotherapyopdoutexaminationdeeptendenreflexesSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES:
            return {
                ...state,
                physiotherapyexaminationdeeptendenreflexesUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES:
            return {
                ...state,
                physiotherapyexaminationdeeptendenreflexesDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDEXAMINATIONLEANDFOOT:
            return {
                ...state,
                physiotherapyexaminationlowerlegangleandfootList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT:
            return {
                ...state,
                physiotherapyopdoutexaminationlowerlegangleandfootSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT:
            return {
                ...state,
                physiotherapyexaminationlowerlegangleandfootUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT:
            return {
                ...state,
                physiotherapyexaminationlowerlegangleandfootDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDEXAMINATIONKNEE:
            return {
                ...state,
                physiotherapyexaminationkneeList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE:
            return {
                ...state,
                physiotherapyopdoutexaminationkneeSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE:
            return {
                ...state,
                physiotherapyexaminationkneeUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE:
            return {
                ...state,
                physiotherapyexaminationkneeDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDEXAMINATIONHIP:
            return {
                ...state,
                physiotherapyexaminationhipList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP:
            return {
                ...state,
                physiotherapyopdoutexaminationhipSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP:
            return {
                ...state,
                physiotherapyexaminationhipUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP:
            return {
                ...state,
                physiotherapyexaminationhipDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDEXAMINATIONTHORACICSPINE:
            return {
                ...state,
                physiotherapyexaminationthoracicspineList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE:
            return {
                ...state,
                physiotherapyopdoutexaminationthoracicspineSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE:
            return {
                ...state,
                physiotherapyexaminationthoracicspineUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE:
            return {
                ...state,
                physiotherapyexaminationthoracicspineDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDEXAMINATIONWRISTANDFINGERS:
            return {
                ...state,
                physiotherapyexaminationwristandfingersList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS:
            return {
                ...state,
                physiotherapyopdoutexaminationwristandfingersSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS:
            return {
                ...state,
                physiotherapyexaminationwristandfingersUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS:
            return {
                ...state,
                physiotherapyexaminationwristandfingersDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDEXAMINATIONELBOW:
            return {
                ...state,
                physiotherapyexaminationelbowList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW:
            return {
                ...state,
                physiotherapyopdoutexaminationelbowSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW:
            return {
                ...state,
                physiotherapyexaminationelbowUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW:
            return {
                ...state,
                physiotherapyexaminationelbowDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDEXAMINATIONSHOLDER:
            return {
                ...state,
                physiotherapyexaminationsholderList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER:
            return {
                ...state,
                physiotherapyopdoutexaminationsholderSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER:
            return {
                ...state,
                physiotherapyexaminationsholderUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER:
            return {
                ...state,
                physiotherapyexaminationsholderDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDEXAMINATIONTEMROMANDIBULARJOINT:
            return {
                ...state,
                physiotherapyexaminationtemromandibularjointList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT:
            return {
                ...state,
                physiotherapyopdoutexaminationtemromandibularjointSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT:
            return {
                ...state,
                physiotherapyexaminationtemromandibularjointUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT:
            return {
                ...state,
                physiotherapyexaminationtemromandibularjointDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDEXAMINATIONCERVICALSPINE:
            return {
                ...state,
                physiotherapyexaminationcervicalspineList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE:
            return {
                ...state,
                physiotherapyopdoutexaminationcervicalspineSaveStatus: action.payload.success,
            }

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE:
            return {
                ...state,
                physiotherapyexaminationcervicalspineUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE:
            return {
                ...state,
                physiotherapyexaminationcervicalspineDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDOUTEXAMINATION:
            return {
                ...state,
                physiotherapyOpdOutExaminationList: action.payload.data
            }

        case CREATEPHYSIOTHERAPYOPDOUTEXAMINATION:
            return {
                ...state,
                physiotherapyOpdOutExaminationList: [action.payload, ...state.physiotherapyOpdOutList], // Add new record to the beginning
            };

        case UPDATEPHYSIOTHERAPYOPDOUTEXAMINATION:
            return {
                ...state,
                physiotherapyexaminationopdUpdateStatus: action.payload.success,
            }

        case DELETEPHYSIOTHERAPYOPDOUTEXAMINATION:
            return {
                ...state,
                physiotherapypexaminationopdDeleteStatus: action.payload.success,
            }
        case GETPHYSIOTHERAPYOPDOUT:
            return {
                ...state,
                physiotherapyOpdOutList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
            };

        case CREATEPHYSIOTHERAPYOPDOUT:
            return {
                ...state,
                physiotherapyOpdOutList: [action.payload, ...state.physiotherapyOpdOutList], // Add new record to the beginning
            };

        case UPDATEPHYSIOTHERAPYPAINASSESSMENTOPDOUT:
            return {
                ...state,
                physiotherapypainassesmentopdUpdateStatus: action.payload.success,
            }

        case DELETEPHYSIOTHERAPYPAINASSESSMENTOPD:
            return {
                ...state,
                physiotherapypainassesmentopdDeleteStatus: action.payload.success,
            }

        case GETPHYSIOTHERAPYOPDOUTBODYCHARTTYPE:
            return {
                ...state,
                physiotherapyOpdOutBodyChartTypeList: action.payload.data,
            }
        case CREATEPHYSIOTHERAPYOPDOUTBODYCHARTTYPE:
            return {
                ...state,
                physiotherapypainassesmentbodychartopdSaveStatus: action.payload.success,
            };

        case UPDATEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD:
            return {
                ...state,
                physiotherapypainassesmentopdbodychartUpdateStatus: action.payload.success,
            }
        case DELETEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD:
            return {
                ...state,
                physiotherapypainassesmentopdbadychartDeleteStatus: action.payload.success,
            }



        default:
            return state;
    }
}